// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Navbar$Showside from "./Navbar.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as ListPageLayoutController$Showside from "../hook/ListPageLayoutController.bs.js";
import * as StickyHeaderOffsetProvider$Showside from "../context/StickyHeaderOffsetProvider.bs.js";
function ListPagePills(Props) {
  var topLevelCategories = Props.topLevelCategories;
  var activeCategory = Props.activeCategory;
  ConfigurationProvider$Showside.use(undefined);
  var match = EntrypointContext$Showside.use(undefined);
  var match$1 = ListPageLayoutController$Showside.Context.use(undefined);
  var match$2 = match$1.state;
  var offsetForStickyElements = StickyHeaderOffsetProvider$Showside.useEffective(undefined);
  var offsetForStickyElements$1 = match.embedType === /* Inline */1 ? offsetForStickyElements : 0;
  var offset = match$2.showPrimaryNavbar ? match$2.primaryNavbarHeight + offsetForStickyElements$1 | 0 : offsetForStickyElements$1;
  return React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["smartnav-pills", "sticky bg-main", "transition-top duration-300 z-20"])),
    style: {
      top: CSS$Showside.intToPx(offset - 1 | 0)
    }
  }, React.createElement(Navbar$Showside.SecondaryNavbar.make, {
    topLevelCategories: topLevelCategories,
    activeCategory: activeCategory,
    keepDynamic: false
  }));
}
ListPagePills.displayName = "ListPagePills";
var make = ListPagePills;
export { make };
/* react Not a pure module */